import {CreateMaintenanceNotification} from '@domain/shifthandover'
import {ShiftEvent} from '@hconnect/common/types'
import {UseMutationResult} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import React from 'react'

import {EquipmentUpdateDialog} from './EquipmentUpdateDialog'

type Props = {
  event: ShiftEvent
  showDialog: boolean
  setDialog: (state: boolean) => void
  onNotificationCreated(): void
  onError?()
  createNotification: UseMutationResult<string, AxiosError, CreateMaintenanceNotification>
  plantId: string
  onSapPmNotification?: (timezone: string) => void
}

export const CreateSapMaintenanceNotification: React.FC<Props> = ({
  event,
  showDialog,
  setDialog,
  onError,
  onNotificationCreated,
  createNotification: createNotificationProp,
  plantId,
  onSapPmNotification
}) => {
  const createNotification = (notification: CreateMaintenanceNotification) => {
    createNotificationProp.mutate(
      {
        ...notification
      },
      {
        onError: onError,
        onSuccess: onNotificationCreated
      }
    )
    setDialog(false)
  }

  return (
    <EquipmentUpdateDialog
      open={showDialog}
      onClose={() => {
        setDialog(false)
      }}
      onConfirm={createNotification}
      event={event}
      plantId={plantId}
      onSapPmNotification={onSapPmNotification}
    />
  )
}
